import React, { useState } from "react";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import GoogleMapReact from "google-map-react";
import pointMarker from "../../Assets/Group 17999.png";
import eventMarker from "../../Assets/Event.png";
import serviceMarker from "../../Assets/Services.png";
import manIcon from "../../Assets/manIcon.png";
import { useEffect } from "react";
import API from "../../Config/API";
import Modal from "react-bootstrap/Modal";
import PointsOfInterstCart from "../PointsOfInterstCart";
import EventsCard from "../EventsCard";
import ServicesCard from "../ServicesCard";
import { useLocation } from "react-router-dom";
import PremiumPointsOfInterstCard from "../PremiumPointsOfInterstCard";
// let b = [
//   {
//     id: 21,
//     name: "Centro Cultural Quinto Cecilio",
//     points: [
//       {
//         id: 132,
//         latitude: "38.962415314453",
//         longitude: "-5.9599532777737",
//         titleEnglish: null,
//         titleFrench: null,
//         titleItalian: null,
//         titlePortuguese: null,
//         titleGerman: null,
//         titleChinese: null,
//         videosSigned: null,
//       },
//       {
//         id: 133,
//         latitude: "38.962415314453",
//         longitude: "-5.9599532777737",
//         titleEnglish: null,
//         titleFrench: null,
//         titleItalian: null,
//         titlePortuguese: null,
//         titleGerman: null,
//         titleChinese: null,
//         videosSigned: null,
//       },
//       {
//         id: 134,
//         latitude: "38.962415314453",
//         longitude: "-5.9599532777737",
//         titleEnglish: null,
//         titleFrench: null,
//         titleItalian: null,
//         titlePortuguese: null,
//         titleGerman: null,
//         titleChinese: null,
//         videosSigned: null,
//       },
//     ],
//   },
//   {
//     id: 21,
//     name: "Centro Cultural Quinto Cecilio",
//     points: [
//       {
//         id: 132,
//         latitude: "38.962415314453",
//         longitude: "-5.9599532777737",
//         titleEnglish: null,
//         titleFrench: null,
//         titleItalian: null,
//         titlePortuguese: null,
//         titleGerman: null,
//         titleChinese: null,
//         videosSigned: null,
//       },
//       {
//         id: 133,
//         latitude: "38.962415314453",
//         longitude: "-5.9599532777737",
//         titleEnglish: null,
//         titleFrench: null,
//         titleItalian: null,
//         titlePortuguese: null,
//         titleGerman: null,
//         titleChinese: null,
//         videosSigned: null,
//       },
//       {
//         id: 134,
//         latitude: "38.962415314453",
//         longitude: "-5.9599532777737",
//         titleEnglish: null,
//         titleFrench: null,
//         titleItalian: null,
//         titlePortuguese: null,
//         titleGerman: null,
//         titleChinese: null,
//         videosSigned: null,
//       },
//     ],
//   },
// ];

const Component = () => {
  const [value, setValue] = useState(null);

  return (
    <div>
      <GooglePlacesAutocomplete
        apiKey="AIzaSyCPr-b3VlC4X08HU1jYqBPYeZrzt_Ci0SE"
        selectProps={{
          value,
          onChange: setValue,
        }}
      />
    </div>
  );
};

const AnyReactComponent = ({ onDragEnd, onClick, src, width, height }) => {
  const handleDrag = (e) => {
    onDragEnd({ lat: e.lat, lng: e.lng });
  };

  return (
    <div
      style={{
        zIndex: 999,
        position: "relative",
        bottom: "20px",
        right: "20px",
      }}
      draggable={true}
      onDragEnd={handleDrag}
      onClick={onClick}
    >
      <img
        src={src}
        width={width ? width : "50px"}
        height={height && height}
        alt="marker "
      />
    </div>
  );
};

function ModalComp({ show, setShow, value, type }) {
  const handleClose = () => setShow(false);

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered={true}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          // padding: "10px",
        }}
      >
        {type === "points" &&
          (value?.points ? (
            <PremiumPointsOfInterstCard value={value} />
          ) : (
            <PointsOfInterstCart value={value} />
          ))}
        {type === "events" && <EventsCard value={value} />}
        {type === "service" && <ServicesCard value={value} />}
      </Modal>
    </>
  );
}

const GoogleMap = ({ latLong }) => {
  const [getLatLong, setGetLatLong] = useState({});
  const [value, setValue] = useState({});
  const [type, setType] = useState("");
  const [pointsData, setPointsData] = useState([]);
  const [eventsData, setEventsData] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [currentUser, setCurrentUser] = useState("");
  const [currentLang, setCurrentLang] = useState("");
  const [currentLocation, setCurrentLocation] = useState("");
  const [isLoading, setIsLoading] = useState("");
  const [isApiCallInProgress, setIsApiCallInProgress] = useState(false);
  const [show, setShow] = useState(false);
  const { state } = useLocation();

  const defaultProps = {
    center: {
      lat: 39.21377454981294,
      lng: -3.4179556504347497,
    },
    zoom: 5,
  };
  const defaultMapOptions = {
    disableDefaultUI: true,
  };

  useEffect(() => {
    // Get User
    const user = localStorage.getItem("UserDetails");
    const parsedUser = JSON.parse(user);
    setCurrentUser(parsedUser);

    // Get Current Location
    const currentLocation = localStorage.getItem("currentLocation");
    const parsedLocation = JSON.parse(currentLocation);
    setCurrentLocation(parsedLocation);

    // Get Language
    const userLang = localStorage.getItem("userLanguage");
    setCurrentLang(userLang);
  }, []);

  useEffect(() => {
    if (!isApiCallInProgress) {
      setIsApiCallInProgress(true);
      getEvents();
      getPoints();
      getService();
    }
  }, [currentUser, currentLang, currentLocation]);

  // Getting Points
  const getPoints = async () => {
    setIsLoading(true);

    try {
      let data;
      let url;

      if (currentUser) {
        url = "/get-points";
        data = await API.post(url, {
          userId: currentUser?.id,
          distance: "10000",
        });
      } else {
        url = "/get-points-web";
        data = await API.post(url, {
          language: currentLang || "Spanish",
          lat: currentLocation?.latitude || "",
          long: currentLocation?.longitude || "",
        });
      }

      let points = data?.data?.data;
      let premiumPoints = data?.data.premium;

      const activePoints = points?.filter(
        (point) => point?.status?.toLowerCase() === "active"
      );

      let filteredArray = premiumPoints.filter((item) => {
        return item.points.some(
          (point) => point.status.toLowerCase() === "active"
        );
      });
      let mergedPoints = [...activePoints, ...filteredArray];

      // Filter only the points with status "Active"

      setPointsData(mergedPoints);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      setIsApiCallInProgress(false);
    }
  };

  // Getting Events
  const getEvents = async () => {
    setIsLoading(true);

    try {
      let res;
      if (currentUser) {
        // API call for authenticated user
        res = await API.post("/get-events", { userId: currentUser?.id });
      } else {
        // API call for non-authenticated user
        res = await API.post("/get-events-web", {
          language: currentLang || "Spanish",
          lat: currentLocation?.latitude || "",
          long: currentLocation?.longitude || "",
        });
      }

      // Extract events and premium events from the response
      const events = res?.data?.data || [];
      const premiumEvents = res?.data?.premium;

      // Filter only the events with status "Active"
      const activeEvents = events.filter((event) => event.status === "Active");

      // Combine active events and active premium events into a single array
      const allEvents = [...activeEvents, ...premiumEvents];

      // Set the combined events to the "EventsData" state
      setEventsData(allEvents);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      setIsApiCallInProgress(false);
    }
  };
  const getService = async () => {
    setIsLoading(true);

    try {
      let res;
      if (currentUser) {
        res = await API.post("/get-services", { userId: currentUser?.id });
      } else {
        res = await API.post("/get-services-web", {
          language: currentLang || "Spanish",
          lat: currentLocation?.latitude || "",
          long: currentLocation?.longitude || "",
        });
      }

      const services = res?.data?.data || [];

      const activeServices = services.filter(
        (service) => service.status === "Active"
      );

      setServiceData(activeServices);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      setIsApiCallInProgress(false);
    }
  };

  return (
    <>
      <ModalComp show={show} setShow={setShow} value={value} type={type} />
      {/* <Component /> */}
      <div style={{ height: "80vh", width: "100%" }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: "AIzaSyCPr-b3VlC4X08HU1jYqBPYeZrzt_Ci0SE" }}
          defaultCenter={defaultProps.center}
          defaultZoom={defaultProps.zoom}
          // options={defaultMapOptions}
        >
          {!state &&
            pointsData &&
            pointsData?.map((val, ind) => {
              return (
                (val?.latitude ||
                  val?.longitude ||
                  val?.points[0]?.longitude ||
                  val?.points[0]?.latitude) && (
                  <AnyReactComponent
                    lat={Number(
                      val?.points ? val?.points[0]?.latitude : val?.latitude
                    )}
                    lng={Number(
                      val?.points ? val?.points[0]?.longitude : val?.longitude
                    )}
                    text="Point Marker"
                    src={pointMarker}
                    onClick={() => {
                      setShow(true);
                      setValue(val);
                      setType("points");
                    }}
                    key={ind}
                  />
                )
              );
            })}

          {!state &&
            eventsData &&
            eventsData?.map((val) => {
              return (
                (val?.latitude || val?.longitude) && (
                  <AnyReactComponent
                    lat={Number(val?.latitude)}
                    lng={Number(val?.longitude)}
                    text="Event Marker"
                    src={eventMarker}
                    onClick={() => {
                      setShow(true);
                      setValue(val);
                      setType("events");
                    }}
                    key={val?.id}
                  />
                )
              );
            })}
          {!state &&
            serviceData &&
            serviceData?.map((val) => {
              return (
                (val?.latitude || val?.longitude) && (
                  <AnyReactComponent
                    lat={Number(val?.latitude)}
                    lng={Number(val?.longitude)}
                    text="service Marker"
                    src={serviceMarker}
                    width={20}
                    height={30}
                    onClick={() => {
                      setShow(true);
                      setValue(val);
                      setType("service");
                    }}
                    key={val?.id}
                  />
                )
              );
            })}
          {state &&
            (state.type === "point" ? (
              <AnyReactComponent
                lat={Number(state?.latitude)}
                lng={Number(state?.longitude)}
                text="Point Marker"
                src={pointMarker}
                onClick={() => {
                  setShow(true);
                  setValue(state);
                  setType("points");
                }}
                onDragEnd={(e) => {
                  setGetLatLong(e);
                }}
                key={state?.id}
              />
            ) : (
              ""
            ))}
        </GoogleMapReact>
      </div>
    </>
  );
};

export default GoogleMap;
